import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#081226]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <span className="block h-10 w-10 overflow-hidden rounded-full ring-1 ring-white/20">
                <img src="/assets/knot-logo.png" alt="Knot Forgotten logo" className="h-full w-full object-cover" />
              </span>
              <span className="text-base font-bold tracking-tight text-white">Knot Forgotten</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              Everything about your boat. In one place.
            </p>
          </div>

          <nav className="flex flex-col gap-3 text-sm" aria-label="Footer">
            <span className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-[#25A5B7]">Navigate</span>
            <Link to="/" data-testid="footer-home-link" className="text-slate-300 transition-colors hover:text-white">Home</Link>
            <Link to="/privacy" data-testid="footer-privacy-link" className="text-slate-300 transition-colors hover:text-white">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link" className="text-slate-300 transition-colors hover:text-white">Terms of Use</Link>
            <Link to="/support" data-testid="footer-support-link" className="text-slate-300 transition-colors hover:text-white">Support</Link>
          </nav>

          <div className="flex flex-col gap-3 text-sm">
            <span className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-[#25A5B7]">Contact</span>
            <a
              href="mailto:knotforgottenapp@gmail.com"
              data-testid="footer-email-link"
              className="text-slate-300 transition-colors hover:text-white"
            >
              knotforgottenapp@gmail.com
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 Knot Forgotten</span>
          <span className="font-mono-label tracking-wider">iOS · COMING SOON TO THE APP STORE</span>
        </div>
      </div>
    </footer>
  );
}
